/**
 * @description Games 列单元格渲染组件
 */
import React, { useMemo } from 'react';
import classnames from 'classnames';
import { getIntl } from 'umi';
import TableImg from '@intelligence/components/TableComponents/components/TableImg';

import './GamesListCell.scss';

/**
 * 游戏信息
 */
interface IGameInfo {
  entity_name?: string;
  cover?: string;
}

interface IGamesListCellProps extends IBaseProps {
  /** 实体类型 */
  entityType: IEntityType;
  /** 游戏ID列表 */
  gameIds: string[];
  /** 游戏信息Map */
  entityInfoMap: IRecord<IGameInfo>;
  /** More按钮点击回调（由父组件通过闭包传递参数） */
  onMoreClick?: () => void;
}

/** 最大显示游戏数量 */
const MAX_DISPLAY_GAMES = 4;

const GamesListCell: React.FC<IGamesListCellProps> = (props) => {
  const { style, className, entityType, gameIds, entityInfoMap, onMoreClick } = props;

  const { formatMessage } = getIntl();

  /**
   * 构建游戏图片列表数据
   */
  const gameImages = useMemo(() => {
    if (!Array.isArray(gameIds) || gameIds.length === 0) {
      return [];
    }

    return gameIds.slice(0, MAX_DISPLAY_GAMES).map((gameId) => {
      const gameInfo = entityInfoMap?.[gameId] || {};
      const gameCover = gameInfo?.cover || '';

      return {
        name: gameInfo?.entity_name || '',
        cover: gameCover,
        imgSrc: gameCover,
      };
    });
  }, [gameIds, entityInfoMap]);

  /**
   * 处理More按钮点击
   */
  const handleMoreClick = () => {
    onMoreClick?.();
  };

  /**
   * 没有游戏数据
   */
  if (gameImages.length === 0) {
    return <span className="dbi-games-list-cell__empty">-</span>;
  }

  return (
    <div style={style} className={classnames('dbi-games-list-cell', className)}>
      <TableImg isNeedMogr entityType={entityType} cvm={gameImages} />
      <button className="dbi-games-list-cell__more-btn" type="button" onClick={handleMoreClick}>
        {formatMessage({ id: 'dbi_more' })}
      </button>
    </div>
  );
};

export default GamesListCell;
